import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { PokemonCard } from '../types/pokemon';

export function useSimilarCards(cardName: string | null, currentCardId: number) {
  const [cards, setCards] = useState<PokemonCard[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSimilarCards = async () => {
      if (!cardName) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('cards')
          .select('*')
          .eq('card_fr', cardName)
          .neq('id', currentCardId);

        if (error) throw error;
        setCards(data || []);
      } catch (err) {
        console.error('Error fetching similar cards:', err);
        setError(err instanceof Error ? err.message : 'Une erreur est survenue');
      } finally {
        setLoading(false);
      }
    };

    fetchSimilarCards();
  }, [cardName, currentCardId]);

  return { cards, loading, error };
}